export interface SendNotificationResponseDto {
  notificationId: string; // Guid
  totalRecipients: number;
  sentDate: string; // DateTime as ISO string
  status: string;
}
